import { dialogDefault, DIALOG_PAYMENT } from "../consts";

const mydialog = { ...dialogDefault }

export const dialogPayment = payload => ({ type: DIALOG_PAYMENT, payload });

export default function paymentDialogReducer(state = mydialog, { type, payload }) {
    const actions = {
        [DIALOG_PAYMENT] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}